const text = {
    required: (field, isMulti = false) => `${field} ${isMulti ? 'are' : 'is'} required`,
    length: (field, length, type) => `${field} must be ${length} char ${type}`,
    value: (field, value, type) => `${type} ${field} must be ${value}`,
    invalid_field: (field, isMulti = false) => `${field} ${isMulti ? 'are' : 'is'} invalid`,
    has_protocol: protocols => `Only ${protocols.join(', ')} protocols are supported`,
    has_number: field => `${field} must contain at least 1 number`,
    has_char: field => `${field} must contain at least 1 special char`,
    has_case: (field, type) => `${field} must contain at least 1 ${type} letter`,
    like_email: field => `${field} must match to email format`,
    digits: (field, length) => `${field} must be a ${length}-digit number `,
    is_same: (field, match) => `${field} must be same with ${match}`,
    should_select: field => `At least 1 ${field} should be selected.`,
    can_be_used: (field, length) => `Only ${length} ${field} can be used.`,
    must_be_type: (field, type) => `${field} must be ${type}`,
    must_be_between: (field, min, max) => `${field} must be between ${min} and ${max}`,
    one_of: (field, data) => `${field} must be one of ${data.join(', ')}`,
    invalid_file_size: (field, size) => `Please upload a ${field} with a file size of up to ${size}`,
    invalid_file_type: field => `Invalid file type for ${field}`,
    invalid_dimension: field => `The ${field} image should be square`,
    choose_field: field => `Choose ${field}`,
    failed_load_file: 'File cannot be uploaded. Please try later.',
    end_time_validation: (field1, field2) => `${field1} must be later than ${field2}`
}

export const realTimeValidationText = {
    required: () => 'This field is required',
    length: (length, type) => `Must be ${length} char ${type}`,
    has_number: () => 'Must contain at least 1 number',
    has_char: () => 'Must contain at least 1 special char',
    has_case: (type) => `Must contain at least 1 ${type} letter`,
    like_email: () => 'Must match to email format',
    digits: (length) => `Must be a ${length}-digit number `,
    is_same: (match) => `Must be same with ${match}`
}

export default text
